/**
 * @generated SignedSource<<9a9a538d6d283afc3755258661404b48>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TodoEditAssigneesPopoverRolesMutation$variables = {
  employeeId?: string | null;
  id: string;
  roleIds: ReadonlyArray<string>;
};
export type TodoEditAssigneesPopoverRolesMutation$data = {
  readonly todo: {
    readonly updateAssignedRoles: {
      readonly assignedRoles: ReadonlyArray<{
        readonly role: {
          readonly id: string;
        };
      }>;
      readonly id: string;
    };
  } | null;
};
export type TodoEditAssigneesPopoverRolesMutation$rawResponse = {
  readonly todo: {
    readonly updateAssignedRoles: {
      readonly assignedRoles: ReadonlyArray<{
        readonly id: string;
        readonly role: {
          readonly id: string;
        };
      }>;
      readonly id: string;
    };
  } | null;
};
export type TodoEditAssigneesPopoverRolesMutation = {
  rawResponse: TodoEditAssigneesPopoverRolesMutation$rawResponse;
  response: TodoEditAssigneesPopoverRolesMutation$data;
  variables: TodoEditAssigneesPopoverRolesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "roleIds"
},
v3 = [
  {
    "kind": "Variable",
    "name": "employeeId",
    "variableName": "employeeId"
  },
  {
    "kind": "Variable",
    "name": "todoId",
    "variableName": "id"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "updateAssignedRoleIds",
    "variableName": "roleIds"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "EmployeeRole",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoEditAssigneesPopoverRolesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "updateAssignedRoles",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AssignedRole",
                "kind": "LinkedField",
                "name": "assignedRoles",
                "plural": true,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TodoEditAssigneesPopoverRolesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "updateAssignedRoles",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AssignedRole",
                "kind": "LinkedField",
                "name": "assignedRoles",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0a66dc79458edebc895f693028deb103",
    "id": null,
    "metadata": {},
    "name": "TodoEditAssigneesPopoverRolesMutation",
    "operationKind": "mutation",
    "text": "mutation TodoEditAssigneesPopoverRolesMutation(\n  $id: ID!\n  $roleIds: [ID!]!\n  $employeeId: ID\n) {\n  todo(todoId: $id, employeeId: $employeeId) {\n    updateAssignedRoles(updateAssignedRoleIds: $roleIds) {\n      id\n      assignedRoles {\n        role {\n          id\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "02ea4d16caa25c1061f88fa2418d7f1f";

export default node;
